import { IconButton, Stack, Typography } from '@mui/material';
import { useObservable } from '@ngneat/react-rxjs';
import { useEffect, useState } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';

import { clientDetailsQuery, clientDetailsService } from '@store/clients/details';
import { clientsServicesService } from '@store/clients/services';
import { clientsUnitsService } from '@store/clients/units';

import { ClientDetailsRoutes } from '@utils/routes.utils';

import { ArrowBack } from '@icons/index';

import RoutesTabsComponent from '@components/tabs/RoutesTabs.component';

import { documentsService } from '@store/documents';

const ClientDetailsScreen = () => {
  const navigate = useNavigate();
  const { clientId } = useParams();

  const [{ headOffice}] = useObservable(clientDetailsQuery.clientDetails$);
  const [selectedFile] = useState<File | undefined>();
  const [pictureId, setPictureId] = useState<number>();

  useEffect(() => {
    if (clientId) {
      clientDetailsService.getClientById(clientId).subscribe(
        (res) => setPictureId(res.logoPictureDocumentId)
      );
      clientDetailsService.getInvoiceAddresses(clientId).subscribe();
    }

    return () => {
      clientDetailsService.resetStore();
      clientsUnitsService.resetStore();
      clientsServicesService.resetStore();
      documentsService.resetStore();
    };
  }, [clientId]);

  useEffect(() => {
    if (selectedFile) {
      URL.createObjectURL(selectedFile);
    } else {
      return undefined;
    }
  }, [pictureId, selectedFile]);

  if (!headOffice.name) return null;

  const handleClose = () => {
    navigate('..', { replace: true });
  };

  return (
    <Stack flex={1} width="100%" pt="34px" px="24px" spacing={3} overflow="hidden">
      <Stack direction="row" alignItems="center" justifyContent="flex-start" spacing={1} ml="-9px">
        <IconButton onClick={handleClose}>
          <ArrowBack />
        </IconButton>
        <Typography fontSize="30px" fontWeight="700">
          {headOffice?.name}
        </Typography>
      </Stack>
      <Stack flex={1} spacing={2} overflow="hidden">
        <Stack flex={1} overflow="hidden">
          <Stack justifyContent="space-between" flexWrap="nowrap" flexDirection="row">
            <Stack>
              <RoutesTabsComponent routes={ClientDetailsRoutes.routes()} />
            </Stack>
          </Stack>
          <Outlet />
        </Stack>
      </Stack>
    </Stack>
  );
};

export default ClientDetailsScreen;
